var _path, _path2, _polygon, _polygon2, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoor3DobjectChair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.857,18.912h18.898c1.172,0,2.124.952,2.124,2.124h0c0,1.172-.952,2.124-2.124,2.124H13.981c-1.172,0-2.124-.952-2.124-2.124v-2.124h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m11.857,18.912l-2.736-15.839h0c2.912,1.719,4.886,4.668,5.363,8.016l1.116,7.822h-3.744Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "13.562 38.926 12.145 38.926 14.911 23.161 18.283 23.161 13.562 38.926"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "30.877 38.926 32.295 38.926 29.528 23.161 26.157 23.161 30.877 38.926"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 17.032,
    y1: 27.339,
    x2: 26.96,
    y2: 27.339
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoor3DobjectChair);
export default __webpack_public_path__ + "static/media/indoor-3dobject_chair.c355f25739568826181461ecfba81368.svg";
export { ForwardRef as ReactComponent };